<template lang="pug">
  #MySa
    appHeader
    router-view.content-body
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'MySaComponent',
  components: {
    appHeader
  }
};
</script>
